'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Container = require('./components/Container.Tabs');

var _Container2 = _interopRequireDefault(_Container);

var _Content = require('./components/Content.Tabs');

var _Content2 = _interopRequireDefault(_Content);

var _Tab = require('./components/Tab.Tabs');

var _Tab2 = _interopRequireDefault(_Tab);

var _Addons = require('./components/Addons.Tabs');

var _Addons2 = _interopRequireDefault(_Addons);

var _Addon = require('./components/Addon.Tabs');

var _Addon2 = _interopRequireDefault(_Addon);

var _Notification = require('./components/Notification.Tabs');

var _Notification2 = _interopRequireDefault(_Notification);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Components


var Tabs = function Tabs(_ref) {
  var tabs = _ref.tabs,
      tab = _ref.tab,
      onChange = _ref.onChange,
      nav = _ref.nav,
      addon = _ref.addon;
  var addonItems = addon(_Addon2.default);
  return _react2.default.createElement(_Container2.default, {
    nav: nav
  }, _react2.default.createElement(_Content2.default, null, tabs.map(function (_ref2) {
    var label = _ref2.label,
        id = _ref2.id,
        notifications = _ref2.notifications;
    return _react2.default.createElement(_Tab2.default, {
      key: id,
      onClick: function onClick(e) {
        return onChange(id);
      },
      nav: nav,
      selected: tab === id
    }, label, !!notifications && _react2.default.createElement(_Notification2.default, {
      small: !nav
    }, notifications));
  })), Array.isArray(addonItems) && addonItems.length > 0 && _react2.default.createElement(_Addons2.default, {
    nav: nav
  }, addonItems));
};

Tabs.propTypes = {
  tabs: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string.isRequired,
    id: _propTypes2.default.string.isRequired,
    notifications: _propTypes2.default.number
  })).isRequired,
  tab: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  nav: _propTypes2.default.bool,
  addon: _propTypes2.default.func
};
Tabs.defaultProps = {
  nav: false,
  addon: function addon() {
    return [];
  }
};
exports.default = Tabs;